export interface IFixListState {
    fixReelsData: number[][];
    fixString: string;
}

export interface IFixSelectorSimple {
    fixString: string;
}

export interface IFixSelectorExtended {
    fixReelsData: number[][];
    fixString: string;
}

export interface IFixData {
    [key: number]: number;
}

export const FixStateDefault = {
    active: false,
    currentIndex: undefined,
    fixArray: [],
    fixArrayPredefined: ['NORMAL'],
    fixCombinations: [],
    fixReelPosition: {},
    saveOnRefresh: false,
    extendedSelector: false
};
